import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { REGISTER_URL } from "@/data/site";

export default function CTABanner() {
  const { t } = useTranslation();
  return (
    <section data-testid="cta-banner" className="relative py-14 lg:py-28 overflow-hidden">

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="card-beam relative p-8 lg:p-14 text-center overflow-hidden cta-banner-card"
        >
          {/* Glow accents */}
          <div className="absolute -top-20 -left-20 w-72 h-72 bg-brand/20 blur-3xl rounded-full pointer-events-none" />
          <div className="absolute -bottom-20 -right-20 w-72 h-72 bg-brand/10 blur-3xl rounded-full pointer-events-none" />

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.15 }}
            className="inline-flex items-center gap-2 pill-mono mb-6"
          >
            <Sparkles size={12} className="text-brand" />
            {t("cta.readyPill")}
          </motion.div>

          <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl font-medium tracking-tight mb-5 leading-[1.05] text-[color:var(--text-1)]">
            {t("cta.title")} <span className="text-gradient-brand font-semibold">{t("cta.titleAccent")}</span>
          </h2>
          <p className="text-[color:var(--text-2)] max-w-2xl mx-auto mb-10 text-sm lg:text-base font-light leading-relaxed">
            {t("cta.subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <motion.a
              href="#challenges"
              data-testid="cta-banner-primary"
              className="btn-solid-brand text-sm px-7 py-3"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
            >
              {t("cta.primary")} <ArrowRight size={14} />
            </motion.a>
            <motion.a
              href={REGISTER_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="cta-banner-secondary"
              className="btn-ghost-gradient text-sm px-7 py-3"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
            >
              {t("cta.secondary")}
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
